<div class="problem-preview-notice">
  <div class="problem-preview-notice__title">{{ problem.title }}</div>
  <div class="problem-preview-notice__date-fix">{{ 'PLANED_DATE_FIX' | translate }}</div>
  <div class="problem-preview-notice__date">{{ problem.fixDate | date: 'HH:mm dd-MM-yyyy' }}</div>
  <div class="problem-preview-notice__desc">{{ problem.description | truncate: 150 }}</div>
</div>
